import React, { useState, useEffect } from "react";
import ReactStackedBarChart from "../../sharedComponents/reactStackedBarChart";

export default function ProgressWeightChart({ weightChart, weightChange }) {
	const [chartData, setChartData] = useState({});
	const trimChartData = (weightChart) => {
		if (weightChart && weightChart.length) {
			const data_categories = [];
			const data = [];
			const data_member = [];
			if (weightChart.length > 12) {
				const lastElevenItems = weightChart.slice(weightChart.length - 11, weightChart.length);
				const trimmedData = [weightChart[0], ...lastElevenItems];
				trimmedData.forEach((item) => {
					data_categories.push(item.x);
					if (item.z === 0){
						data.push({'x': item.x, 'y': item.y});
						data_member.push({'x': item.x, 'y': 0});
					}
					else {
						data.push({'x': item.x, 'y':0});
						data_member.push({'x': item.x, 'y': item.y});
					}
				});
			} else {
				weightChart.forEach((item) => {
					data_categories.push(item.x);
					if (item.z === 0){
						data.push({'x': item.x, 'y': item.y});
						data_member.push({'x': item.x, 'y': 0});
					}
					else {
						data.push({'x': item.x, 'y':0});
						data_member.push({'x': item.x, 'y': item.y});
					}
				});
			}

			const data_series = [
				{
					data: data,
					color: "#2cafa4",
					id: 1,
					name: "Weight Chart",
					type: "bar"
				},
				{
					data: data_member,
					color: "#0074bc",
					id: 2,
					name: "Member Weight Chart",
					type: "bar"
				}
			];
			setChartData({ data_categories, data_series });
		}
	};

	useEffect(() => {
		trimChartData(weightChart);
	}, [weightChart]);

	return (
		<div className="card card-primary w-100 h-100 m-0 p-4 border-0 featured-recipes-list">
			<h4 className="text-primary-dark">Weight Chart</h4>
			<div className="pt-3 last-child-b-0">
				<ReactStackedBarChart data={chartData} height={40} />
			</div>
			{weightChange && <div className="text-center">
				Total weight change to date: {weightChange}
			</div>}
		</div>
	);
}
